<template>

   <v-dialog 
    v-model="activeMode"  
    max-width="500"
    @click:outside="closeForm()"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    
    <template v-slot:activator="{ on }">
      <v-btn v-if="channel" icon v-on="on">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      
      <v-btn v-else 
        fab 
        dark 
        small 
        color="primary"
        v-on="on"
      >
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </template>
    
    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>

         <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      
       <v-card-text class="mt-7">
        <v-alert 
          dense 
          outlined
          type="error" 
          :value="Boolean(error)"
          transition="scale-transition"
        >
          {{ error }}
        </v-alert>

        <v-form ref="form" v-model="isValid">
          <v-text-field
            v-model="channelObj.name"
            label="Название канала *"
            filled
            required
            :disabled="channelObj._basechannel"
            :rules="[v => !!v || 'Введите название канала.']"
          >
          </v-text-field>
          <v-text-field
            v-model="channelObj.tagName"
            label="Тэг канала *"
            filled
            required
            :disabled="channelObj._basechannel"
            :rules="[v => !!v || 'Введите тэг канала', v => !v || (channelObj._basechannel || v != '-') || 'Некорректный тэг канала']"
            @focus="error = ''"
          >
          </v-text-field>
          <v-text-field
            v-model="channelObj.phoneNumber"
            label="Номер телефона"
            filled
            :prefix="phoneNumberPrefix"
            @focus="phoneNumberPrefix = '+7'"
            @blur="channelObj.phoneNumber || (phoneNumberPrefix = '')"
            v-mask="'##########'"
            :rules="[v => !v || (v.length == 10) || 'Введите правильный номер.']"
          >
          </v-text-field>
          <date-picker 
            v-model="channelObj._startedAt" 
            name="Дата старта" 
            @focus="error = ''" 
            :disabled="Boolean(channelObj._basechannel)"
          ></date-picker>
          <date-picker 
            v-model="channelObj._finishedAt" 
            name="Дата окончания" 
            @focus="error = ''"
            :disabled="Boolean(channelObj._basechannel)"
          ></date-picker>
        </v-form>
       </v-card-text>

       <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>
          <v-btn 
            color="blue darken-1" 
            text 
            @click="save"
          >Сохранить</v-btn>

        </v-card-actions>
    </v-card>
   </v-dialog>
</template>

<script>
import _ from 'lodash';
import { getTempId } from '../../../models/common';
import DateTimeLocal from '../../../models/datetime';

export default {
  name: 'marketing-channel',

  model: {
    prop: 'channel',
    event: 'updated'
  },

  props: {
    channel: Object,
    allchannels: Array
  },

  data() {
    return {
      activeMode: false,
      title: this.channel ? `Карточка канала: ${this.channel.name}` : 'Создание канала',

      channelObj: this.channel ? _.cloneDeep(this.channel) : this.setDefaultObj(),
      phoneNumberPrefix: this.channel && this.channel.phoneNumber ? '+7' : '',
      dateMenu: false,
      isValid: false,
      error: ''
    }
  },

  methods: {
    setDefaultObj() {
      return {
        _id: getTempId(),
        name: '',
        tagName: '',
        phoneNumber: '',
        startedAt: null,
        finishedAt: null,
        _startedAt: null,
        _finishedAt: null,
        _basechannel: false
      };
    },

    closeForm(success = false) {
      this.error = '';
      this.activeMode = false;
      this.channelObj = this.channel ? 
        (!success ? _.cloneDeep(this.channel) : this.channelObj) : 
        this.setDefaultObj();
      this.$refs.form.resetValidation();
    },

    save() {
      this.$refs.form.validate();
      
      if (this.isValid) {
        this.error = '';
        this.channelObj.startedAt = DateTimeLocal.getStartDateFromISO(this.channelObj._startedAt);
        this.channelObj.finishedAt = DateTimeLocal.getFinishDateFromISO(this.channelObj._finishedAt);

        if (this.channelObj.startedAt && 
            this.channelObj.finishedAt && 
            this.channelObj.startedAt > this.channelObj.finishedAt
        ) {
          return this.error = 'Дата окончания не должна быть меньше даты старта.';
        }

        for (let element of this.allchannels) {
          if (element == this.channel) continue;
          if (element.tagName == this.channelObj.tagName && 
            DateTimeLocal.haveCommonSegment(
              element.startedAt, element.finishedAt,
              this.channelObj.startedAt, this.channelObj.finishedAt
            )
          ) {
            return this.error = 'Уже существует канал с таким же тегом на указанные даты.';
          }
        }

        this.$emit('updated', this.channelObj);
        this.closeForm(true);
      }
    }
  },
}
</script>